import { render, staticRenderFns } from "./ClassTable.vue?vue&type=template&id=3b33dc48"
import script from "./ClassTable.vue?vue&type=script&lang=js"
export * from "./ClassTable.vue?vue&type=script&lang=js"
import style0 from "./ClassTable.vue?vue&type=style&index=0&id=3b33dc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports